module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('div', {
    staticClass: "title grey--text"
  }, [_vm._v("Recent Journal Entries")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.journalHead,
      "items": _vm.journalList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.trans_desc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.trans_dt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.gl_acc_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.debit_amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.credit_amount))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteJournalTrans(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }], null, false, 2821891296)
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description",
      "rules": [_vm.rules.required],
      "hint": "The narration of this journal entry",
      "persistent-hint": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lJournal.trans_desc),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_desc", $$v)
      },
      expression: "lJournal.trans_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgJournalDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px",
      "return-value": _vm.lJournal.trans_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lJournal, "trans_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lJournal, "trans_dt", $event)
      }
    },
    model: {
      value: (_vm.dtDlg),
      callback: function($$v) {
        _vm.dtDlg = $$v
      },
      expression: "dtDlg"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date",
      "append-icon": "event",
      "readonly": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lJournal.trans_dt),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_dt", $$v)
      },
      expression: "lJournal.trans_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lJournal.trans_dt),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_dt", $$v)
      },
      expression: "lJournal.trans_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dtDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgJournalDt.save(_vm.lJournal.trans_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "rules": [_vm.rules.required],
      "type": "number"
    },
    model: {
      value: (_vm.lJournal.trans_amount),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "trans_amount", $$v)
      },
      expression: "lJournal.trans_amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Debit Account",
      "items": _vm.accHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "rules": [_vm.rules.required],
      "clearable": ""
    },
    model: {
      value: (_vm.lJournal.debit_gl_pair),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "debit_gl_pair", $$v)
      },
      expression: "lJournal.debit_gl_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Credit Account",
      "items": _vm.accHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "rules": [_vm.rules.required],
      "clearable": ""
    },
    model: {
      value: (_vm.lJournal.credit_gl_pair),
      callback: function($$v) {
        _vm.$set(_vm.lJournal, "credit_gl_pair", $$v)
      },
      expression: "lJournal.credit_gl_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "outline": "",
      "color": "info"
    }
  }, [_vm._v("HINT:"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                        Income Adj. - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("bank/cash")]), _vm._v(" as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("unit no.")]), _vm._v(" from whom money is received as credit account\n                      ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Expense Adj. - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("vendor")]), _vm._v(" who receives money as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("bank/cash")]), _vm._v(" as credit\n                      ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Write-off Balance - Choose "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("Bad Debts or Round off")]), _vm._v(" as debit account and "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v("unit no.")]), _vm._v(" as credit account\n                      ")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.beingSaved,
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97797872","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Journal.vue
// module id = 850
// module chunks = 42